export default __webpack_public_path__ + "static/media/c006-b.708d596a.jpg";